import { useRender } from '@base-ui/react/use-render';
import { buttonContent } from './utils/button-content';
import { buttonStyles } from './utils/button-styles';
/**
 * Navigation that looks like a button. Renders an `<a>` (link semantics, no loading state).
 * For actions, use `Button`.
 */
export const ButtonLink = ({ label, variant = 'pink', shape = 'round', className, icon, render, tabIndex = 0, target, rel = target === '_blank' ? 'noopener noreferrer' : undefined, ...props }) => useRender({
    render,
    defaultTagName: 'a',
    props: {
        className: buttonStyles({ variant, shape, className }),
        children: buttonContent(label, icon),
        tabIndex,
        target,
        rel,
        ...props,
    },
});
